import HomePage from '../../pages/home/homePage'
import createHomePageContainer from './createHomePageContainer'

export default createHomePageContainer(HomePage)
